module.exports = __webpack_public_path__ + "static/media/remax.e434450c.webp";